import Basic from './Basic.js';
import Airtable from './Airtable.js';

function App() {
  return (
    <>
      <Basic />
      <Airtable />
    </>
  );
}

export default App;
